import BaseProductSlider from './BaseProductSlider';
import { Product } from '../Product';
export const ProductSlider = {
  ProductSlider_1: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_1} productWidth={100} imageWidth={45} />;
  },
  ProductSlider_2: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_2} productWidth={100} imageWidth={45} />;
  },
  ProductSlider_3: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_3} productWidth={100} imageWidth={45} />;
  },
  ProductSlider_4: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_4} productWidth={100} imageWidth={45} />;
  },
  ProductSlider_5: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_5} productWidth={100} imageWidth={45} />;
  },
  ProductSlider_6: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_6} productWidth={100} imageWidth={45} />;
  },
  ProductSlider_7: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_7} productWidth={100} imageWidth={45} />;
  },
  ProductSlider_8: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_8} productWidth={100} imageWidth={45} />;
  },
  ProductSlider_9: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_9} productWidth={100} imageWidth={45} />;
  },
  ProductSlider_10: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_10} productWidth={100} imageWidth={45} />;
  },
  ProductSlider_11: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_11} productWidth={100} imageWidth={45} />;
  },
  ProductSlider_12: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_12} productWidth={100} imageWidth={45} />;
  },
  ProductSlider_13: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_13} productWidth={100} imageWidth={45} />;
  },
  ProductSlider_14: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_14} productWidth={100} imageWidth={45} />;
  },
  ProductSlider_15: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_15} productWidth={100} imageWidth={45} />;
  },
  ProductSlider_16: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_16} productWidth={100} imageWidth={45} />;
  },
  ProductSlider_17: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_17} productWidth={100} imageWidth={45} />;
  },
  ProductSlider_18: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_18} productWidth={100} imageWidth={45} />;
  },
  ProductSlider_19: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_19} productWidth={100} imageWidth={45} />;
  },
  ProductSlider_20: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_20} productWidth={100} imageWidth={45} />;
  },
  ProductSlider_21: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_21} productWidth={100} imageWidth={45} />;
  },
  ProductSlider_22: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_22} productWidth={100} imageWidth={50} />;
  },
  ProductSlider_23: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_23} productWidth={100} imageWidth={50} />;
  },
  ProductSlider_24: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_24} productWidth={100} imageWidth={50} />;
  },
  ProductSlider_25: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_25} productWidth={100} imageWidth={50} />;
  },
  ProductSlider_26: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_26} productWidth={100} imageWidth={50} />;
  },
  ProductSlider_28: ({ item }) => {
    return <BaseProductSlider item={item} Product={Product?.Product_28} productWidth={100} imageWidth={50} />;
  },
};
